import { useState } from "react";
import { useDispatch } from "react-redux";
import Toastiy from "../../../components/universal/Toastiy";
import { deleteCurriculumAction, readCurriculumAction } from "../../../store/Languages/LanguageAction";

const CurriculumHooks = () => {
  return { value: "", onChangeSearchBar: () => {} };
};

export default CurriculumHooks;

export const AllCurriculumHooks = () => {
  const dispatch = useDispatch();

  const [value, setValue] = useState("");
  const [reloadData, setReloadData] = useState(false);

  const fetchAllCurriculums = (page, limit, searchCriteria = {}, callbackFn) => {
    dispatch(
      readCurriculumAction({
        apiPayloadRequest: {
          page,
          limit,
          searchCriteria,
        },
        callback: (data) => {
          if (!callbackFn) return;

          if (data?.type === 1) {
            callbackFn({
              data: data?.data?.map((d) => ({ ...d, views: d?.views ?? 0 })) ?? [],
              total: data?.totalRecords ?? 0,
            });
            return;
          }

          callbackFn({ data: [], total: data?.totalRecords ?? 0 });
        },
      })
    );
  };

  const onChangeSearchBar = (e) => {
    setValue(e.target.value);
  };

  const handleDeleteItem = (_id) => {
    dispatch(
      deleteCurriculumAction({
        apiPayloadRequest: { _id },
        callback: (res) => {
          if (res?.type === 1) {
            setReloadData(true);
            Toastiy("Curriculum Deleted Successfully!", 1);
            return;
          }

          Toastiy("Curriculum Failed To Delete!");
        },
      })
    );
  };

  return {
    value,
    onChangeSearchBar,
    handleDeleteItem,
    reloadData,
    setReloadData,
    fetchAllCurriculums,
  };
};

export const AddCurriculumHooks = (setLoading, curriculum_id) => {
  const [activeTab, setActiveTab] = useState("en");
  const [curriculumValues, setCurriculumValues] = useState({});
  const [lessonValues, setLessonValues] = useState({});
  const [slideData, setSlideData] = useState({});
  const [lessonsArray, setLessonArray] = useState([]);
  const [layoutArray, setLayoutArray] = useState([]);

  return {
    value: "",
    onChangeSearchBar: () => {},
    languages: ["english", "hindi", "tamil"],
    activeTab,
    setActiveTab,
    openCreateStoryModal: false,
    setOpenCreateStoryModal: () => {},
    layoutInfo: false,
    setLayoutInfo: () => {},
    isEdit: false,
    curriculumValues,
    setCurriculumValues,
    curriculumErrors: {},
    lessonValues,
    setLessonValues,
    lessonErrors: {},
    slideData,
    setSlideData,
    readLanguageData: [],
    isLanguageSave: true,
    languagemeta: [],
    lessonsArray,
    setLessonArray,
    isSlideEdit: false,
    indexEdit: null,
    slideArray: [],
    indexEditSlide: null,
    activeStory: null,
    showPreview: false,
    layoutValues: {},
    addedLayout: false,
    setAddedLayout: () => {},
    editTargetLayout: "",
    isLayoutEdit: false,
    layoutArray,
    editLayoutIndex: null,
    storyData: [],
    updateStateWithTranslation: () => {},
    handleVideoLayoutChange: () => {},
    handleVideoDateChange: () => {},
    handleLayoutUpdate: () => {},
    handleAddLayoutToArray: () => {},
    handleDateChange: () => {},
    handleDeleteLayoutFromArray: () => {},
    handleCurriculumLayoutChange: () => {},
    handleCurriculumInputChange: () => {},
    handleCurriculumUploadInput: () => {},
    handleLessonInputChange: () => {},
    handleLessonUploadInput: () => {},
    handleAddTopic: () => {},
    handleEditLesson: () => {},
    handleDeleteLesson: () => {},
    handleSlideInputChange: () => {},
    handleSlideFileChange: () => {},
    handleColorChange: () => {},
    handleSlideUploadInput: () => {},
    handleOptionChange: () => {},
    handleSlideEdit: () => {},
    handleAddStory: () => {},
    handleCloseStory: () => {},
    handlePublishCurriculum: () => {},
    handleSaveLanguage: () => {},
    setLanguagemeta: () => {},
    setEnCurriculum: () => {},
    setEnLessonArray: () => {},
    setCurrentCurriculumValues: () => {},
    setIsEdit: () => {},
    setIndexEdit: () => {},
    setCurrentLessonArray: () => {},
    setCurrentLessonValues: () => {},
    setIsSlideEdit: () => {},
    setIndexEditSlide: () => {},
    setSlideArray: () => {},
    setShowPreview: () => {},
    setActiveStory: () => {},
    setLayoutArray: () => {},
    setIsLayoutEdit: () => {},
    setEditLayoutIndex: () => {},
    setEditTargetLayout: () => {},
    setLayoutValues: () => {},
    setCurriculumErrors: () => {}
  };
};
